// Map of key to dynamic import function
// Example:
// 'my-plugin': () => import('./my-plugin')
//
// The imported module should export a default function or a 'setup' function
// that takes the plugin data as an argument.
//
// Example plugin implementation:
// export default function(data: any) {
//   console.log('Plugin loaded with data:', data);
// }

export const pluginRegistry: Record<string, () => Promise<unknown>> = {
  // Add your plugins here
  'customsbase-toolbar-comi': () => import('src/plugins/comi'),
  'declaration-gaston-schul': () => import('src/plugins/gastonSchul')
};
